import styled from "styled-components";
import { BACKGROUND_DIM, TEXT_PRIMARY, BORDER_PRIMARY } from "@/constants/colors";
import { FONT_SIZE_BASE, TITLE, BODY, REGULAR, SEMI_BOLD } from "@/constants/fonts";
import { TableHeaderRow, TableRow } from "@/components/generic/Table";

export const RefundTableHeaderRow = styled(TableHeaderRow)`
  height: 54px;
  th:last-child {
    padding-right: 41px;
    text-align: right;
  }
`;

export const RefundTableRow = styled(TableRow)`
  height: 54px;
  border-bottom: ${({ isOpen, isLastRefund }) =>
    isOpen || isLastRefund ? "none" : `1px solid ${BORDER_PRIMARY}`};
  td:first-child {
    padding-left: 24px;
    width: 434px;
  }
  td:last-child {
    padding-right: 17px;
    text-align: right;
  }
`;

export const LineItemTableRow = styled.tr`
  background-color: ${BACKGROUND_DIM};
  width: 100%;
  height: 63px;
  font-family: ${BODY};
  font-size: ${FONT_SIZE_BASE};
  line-height: 22px;
  border-bottom: ${({ isLastLineItem, isLastRefund }) =>
    isLastLineItem && !isLastRefund ? `1px solid ${BORDER_PRIMARY}` : "none"};
  td:first-child {
    padding-left: 24px;
  }
  td:last-child {
    padding-right: 44px;
    text-align: right;
    display: flex;
    justify-content: end;
  }
`;

export const StatusColumn = styled.td`
  width: 96px;
`;

export const LineItemDescription = styled.p`
  color: ${TEXT_PRIMARY};
  font-family: ${TITLE};
  font-weight: ${SEMI_BOLD};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
`;

export const LineItemSubDescription = styled.p`
  color: ${TEXT_PRIMARY};
  font-family: ${BODY};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  text-align: left;
`;

export const LineItemAmount = styled(LineItemDescription)`
  line-height: 22px;
  margin: 16px 0 0 0;
`;
